import { motion } from "framer-motion";

export default function SkeletonCard({ index }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.4,
        delay: index * 0.05,
        repeat: Infinity,
        repeatType: "reverse",
      }}
      className="break-inside-avoid rounded-2xl bg-white shadow-md overflow-hidden mb-6"
    >
      {/* Image skeleton */}
      <div className="w-full h-48 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse" />

      {/* Content skeleton */}
      <div className="p-3 space-y-3">
        <div className="h-4 w-3/4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse" />

        <div className="h-6 w-1/3 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse" />

        <div className="space-y-2">
          <div className="h-3 w-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse" />
          <div className="h-3 w-5/6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse" />
        </div>

        <div className="h-5 w-20 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-full animate-pulse" />
      </div>
    </motion.div>
  );
}